import React from 'react';
import './Footer.css'; // Import the CSS
import logo from "./Dhruvologo.png"

// Placeholder Icons (MUST REPLACE with actual icons, e.g., from react-icons)
// Example using react-icons: import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
const PlaceholderIcon = ({ children }) => <span className="footer-icon-placeholder">{children}</span>;
const FacebookIcon = () => <PlaceholderIcon>f</PlaceholderIcon>; // Replace with <FaFacebookF />
const TwitterIcon = () => <PlaceholderIcon>t</PlaceholderIcon>;  // Replace with <FaTwitter />
const LinkedInIcon = () => <PlaceholderIcon>in</PlaceholderIcon>; // Replace with <FaLinkedinIn />
const InstagramIcon = () => <PlaceholderIcon>ig</PlaceholderIcon>; // Replace with <FaInstagram />
const PhoneIcon = () => <PlaceholderIcon>📞</PlaceholderIcon>;    // Replace with <FaPhoneAlt />
const EmailIcon = () => <PlaceholderIcon>✉️</PlaceholderIcon>;     // Replace with <FaEnvelope />
const AddressIcon = () => <PlaceholderIcon>📍</PlaceholderIcon>;   // Replace with <FaMapMarkerAlt />

// Placeholder Logo (Same as Navbar example - Replace if needed)
const FooterLogo = () => (
     <a href="/" className="footer-logo-link" aria-label="Healthcare Solutions Home">
       <img src={logo} alt="logo" className='footer-logo-svg' />
    </a>
);


function Footer() {
  return (
    <footer className="footer-main">
      {/* Animated Background Elements */}
      <div className="footer-bg-shape footer-shape-1"></div>
      <div className="footer-bg-shape footer-shape-2"></div>
      <div className="footer-bg-noise"></div>

      <div className="footer-container">
        {/* Top Section: Logo, Description, Social */}
        <div className="footer-section footer-section-top">
          <div className="footer-identity">
            <FooterLogo />
            <p className="footer-description">
              Pioneering the future of healthcare staffing and solutions. We connect exceptional talent with vital opportunities, fostering growth and elevating patient care standards globally.
            </p>
          </div>
          <div className="footer-social">
            <h4 className="footer-heading-small">Connect With Us</h4>
            <div className="footer-social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Facebook">
                <FacebookIcon />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Twitter">
                <TwitterIcon />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="LinkedIn">
                <LinkedInIcon />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Instagram">
                <InstagramIcon />
              </a>
            </div>
          </div>
        </div>

        {/* Middle Section: Links */}
        <div className="footer-section footer-section-links">
          <div className="footer-links-column">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links-list">
              <li><a href="/" className="footer-link">Home</a></li>
              <li><a href="/service" className="footer-link">Services</a></li>
              <li><a href="/contact" className="footer-link">Contact Us</a></li>
            </ul>
          </div>
          <div className="footer-links-column">
            <h4 className="footer-heading">About Us</h4>
            <ul className="footer-links-list">
              {/* <li><a href="/ourteam" className="footer-link">Our Team</a></li> */}
              <li><a href="/ourteam" className="footer-link">Our Team</a></li>
              <li><a href="/faq" className="footer-link">FAQ</a></li>
            </ul>
          </div>
          {/* <div className="footer-links-column">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-links-list">
              <li><a href="#privacy" className="footer-link">Privacy Policy</a></li>
              <li><a href="#terms" className="footer-link">Terms of Service</a></li>
              <li><a href="#sitemap" className="footer-link">Sitemap</a></li>
               <li><a href="#accessibility" className="footer-link">Accessibility</a></li>
            </ul>
          </div> */}
          
        {/* Bottom Section: Contact Details */}
        <div className="footer-section footer-section-contact">
           <h4 className="footer-heading">Get In Touch</h4>
           <address className="footer-contact-details">
              
                <a href="mailto:info@healthcaresolutions.com" className="footer-contact-link">
                     <span className="footer-contact-icon"><EmailIcon /></span>
                    cliniqorindia@gmail.com
                </a>
                <p className="footer-contact-address">
                     <span className="footer-contact-icon"><AddressIcon /></span>
                     Pune, Maharashtra - 411028, India
                  
                </p>
           </address>
        </div>
        </div>


      </div>

      {/* Copyright Bar */}
      <div className="footer-bottom-bar">
         <div className="footer-bottom-container">
             <p>© {new Date().getFullYear()}  Cliniqor Healthcare project and manpower Solutions. All Rights Reserved.</p>
             <p className='fottermadewith'>Made with 
              {/* <span className="footer-heart">❤️</span>  */}
             <a href='https://dheersoftwaresolutions.com/' target='_balnk'>Dheer Software Solutions</a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;